import { Divider } from "@evergis/ui";
import React, { FC } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { useSelector } from "react-redux";
import { useResourceSelectorContext } from "../../../../components/ResourceSelector/ResourceSelector";
import { getLocationQuery } from "../../../../ducks/location/selectors";

import { FilterByServiceType } from "../FilterByServiceType";
import { Sort } from "../Sort/Sort";
import { SortByGeometry } from "../SortByGeometry";

import { useResourceType } from "../../../../hooks/useResourceType";
import { useViewType } from "../../hooks/useViewType";

import { ResourceViewType } from "../ViewType/types";

export const Filters: FC = () => {
  const [resourceType] = useResourceType();
  const [viewType] = useViewType();
  const { addAsBasemap } = useSelector(getLocationQuery);
  const { active: resourceSelectorActive } = useResourceSelectorContext();

  return (
    <>
      {resourceType !== ResourceTypeLink.Project && !addAsBasemap && <SortByGeometry />}
      {resourceType === ResourceTypeLink.Layer && !addAsBasemap && !resourceSelectorActive && <FilterByServiceType />}
      {(resourceType === ResourceTypeLink.Layer || resourceType !== ResourceTypeLink.Project) &&
        viewType === ResourceViewType.Grid && <Divider vertical />}
      {viewType === ResourceViewType.Grid && <Sort />}
    </>
  );
};
